import { render, staticRenderFns } from "./ImageViewerDialog.vue?vue&type=template&id=18bfe513&"
import script from "./ImageViewerDialog.vue?vue&type=script&lang=ts&"
export * from "./ImageViewerDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ImageViewerDialog.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VDialog,VImg})
